import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {ContextService} from '@services/context.service';
import {AddressModel} from '@app/models/addresses.model';
import {AddressFormCustomComponent} from '@shared/components/address-form-custom/address-form-custom.component';
import {PrefillRegistrationModel, SelfRegistrationModel} from '@app/models/user-registration.model';

@Component({
  selector: 'app-rapid-registration-page-1',
  templateUrl: './rapid-registration-page-1-info.component.html',
  styleUrls: ['./rapid-registration-page-1-info.component.scss'],
  imports: [
    SharedImports, AddressFormCustomComponent]
})

export class RapidRegistrationPage1InfoComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  recurring: boolean = false;
  isSearching: boolean = false;
  inputObjState: GenericSelectModel;
  setStateId: number;
  incomingAddressMailing = {} as AddressModel;
  inputObjClassification: GenericSelectModel;
  inputObjEmployer: GenericSelectModel;
  inputObjDuesGroup: GenericSelectModel;
  inputObjOccupation: GenericSelectModel;
  setClassificationType: number;
  setEmployerID: number;
  setOccupationID: number;
  setDuesGroupID: number;
  // personRatesModel: RegistrationRatesModel;
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile = {} as SelfRegistrationModel;
  @Input() personPrefill: PrefillRegistrationModel;

  constructor(private formBuilder: FormBuilder, public contextService: ContextService) {
    this.mainForm = this.formBuilder.group({
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      mobile: new FormControl(null),
      classification: new FormControl(null),
      employer: new FormControl(null),
      duesGroup: new FormControl(null),
      occupation: new FormControl(null),
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      zipCode: new FormControl(null, [Validators.required]),
      zip4: new FormControl(null),

    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.personPrefill) {
      if (this.personPrefill.PersonProfileClassificationRequired) {
        this.mainForm.get('classification').setValidators([Validators.required]);
        this.mainForm.get('classification').updateValueAndValidity();
      }
      if (this.personPrefill.EmployerRequired) {
        this.mainForm.get('employer').setValidators([Validators.required]);
        this.mainForm.get('employer').updateValueAndValidity();
      }
      if (this.personPrefill.OccupationRequired) {
        this.mainForm.get('occupation').setValidators([Validators.required]);
        this.mainForm.get('occupation').updateValueAndValidity();
      }
      if (this.personPrefill.PersonProfileDuesGroupRequired) {
        this.mainForm.get('duesGroup').setValidators([Validators.required]);
        this.mainForm.get('duesGroup').updateValueAndValidity();
      }
      this.setClassificationType = this.personPrefill.PersonProfileClassificationID;
      this.setEmployerID = this.personPrefill.EmployerOrganizationID;
      this.setOccupationID = this.personPrefill.OccupationID;
      this.setDuesGroupID = this.personPrefill.PersonProfileDuesGroupID;
      this.mainForm.get('classification').setValue(this.setClassificationType);
      this.mainForm.get('employer').setValue(this.setEmployerID);
      this.mainForm.get('duesGroup').setValue(this.setDuesGroupID);
      this.mainForm.get('occupation').setValue(this.setOccupationID);
      this.initClassification(false);
      this.initEmployer(false);
      this.initOccupation(false);
      this.initDuesGroup(false);
      this.mainForm.get('email').setValue(this.personPrefill.EmailAddress);
      this.mainForm.get('email').disable();
      this.mainForm.get('firstName').setValue(this.personPrefill.FirstName);
      this.mainForm.get('lastName').setValue(this.personPrefill.LastName);
      this.mainForm.get('mobile').setValue(this.personPrefill.MobilePhone);
      this.mainForm.get('address').setValue(this.personPrefill.Address1);
      this.mainForm.get('address2').setValue(this.personPrefill.Address2);
      this.mainForm.get('city').setValue(this.personPrefill.City);
      this.mainForm.get('state').setValue(this.personPrefill.StateProvinceID);
      this.setStateId = this.personPrefill.StateProvinceID;
      this.mainForm.get('zipCode').setValue(this.personPrefill.Zip);
      this.incomingAddressMailing.CountryID = 1;
      this.incomingAddressMailing.Zip = this.personPrefill.Zip;
      this.incomingAddressMailing.Address1 = this.personPrefill.Address1;
      this.incomingAddressMailing.Address2 = this.personPrefill.Address2;
      this.incomingAddressMailing.City = this.personPrefill.City;
      this.incomingAddressMailing.StateProvinceID = this.personPrefill.StateProvinceID;
      this.initData();
    }
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      this.personPrefill.FirstName = this.mainForm.get('firstName').value;
      this.personPrefill.LastName = this.mainForm.get('lastName').value;
      this.personPrefill.EmailAddress = this.mainForm.get('email').value;
      this.personPrefill.MobilePhone = this.mainForm.get('mobile').value;
      this.personPrefill.Address1 = this.mainForm.get('address').value;
      this.personPrefill.Address2 = this.mainForm.get('address2').value;
      this.personPrefill.City = this.mainForm.get('city').value;
      this.personPrefill.StateProvinceID = this.mainForm.get('state').value;
      this.personPrefill.Zip = this.mainForm.get('zipCode').value;

      //this.registrationProfile.OrganizationID = this.personPrefill.OrganizationID;
      if (this.personPrefill.MobilePhone) {
        this.personPrefill.MobilePhone = this.personPrefill.MobilePhone.replace(/\D/g, '');
      }

      this.updateData.emit(this.personPrefill);
    });
  }

  setAddress(addressChanges: AddressModel): void {
    if (addressChanges) {
      this.mainForm.markAsDirty();
      this.registrationProfile.CountryID = 1;
      this.registrationProfile.Address1 = addressChanges.Address1;
      this.registrationProfile.Address2 = addressChanges.Address2;
      this.registrationProfile.City = addressChanges.City;
      this.registrationProfile.StateProvinceID = addressChanges.StateProvinceID;
      this.registrationProfile.Zip = addressChanges.Zip;
      this.mainForm.get('address').setValue(addressChanges.Address1);
      this.mainForm.get('address2').setValue(addressChanges.Address2);
      this.mainForm.get('city').setValue(addressChanges.City);
      this.mainForm.get('state').setValue(addressChanges.StateProvinceID);
      this.mainForm.get('zipCode').setValue(addressChanges.Zip);
    }
  }

  initClassification(disable: boolean): void {
    this.inputObjClassification = {
      labelText: 'Classification',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: this.personPrefill.PersonProfileClassificationRequired,
      data: this.personPrefill.PersonProfileClassificationOptions,
      selectFirstValue: false,
      initSelected: this.setClassificationType,
      disabled: disable,
      canWrite: true
    };
  }

  setClassificationData(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setClassificationType = event[0].ID;
    } else {
      this.setClassificationType = null;
    }
    this.mainForm.markAsDirty();
    this.mainForm.get('classification').setValue(this.setClassificationType);
    this.personPrefill.PersonProfileClassificationID = this.setClassificationType;
  }

  initEmployer(disable: boolean): void {
    this.inputObjEmployer = {
      labelText: 'Employer',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: this.personPrefill.EmployerRequired,
      data: this.personPrefill.EmployerOptions,
      selectFirstValue: false,
      initSelected: this.setEmployerID,
      disabled: disable,
      canWrite: true
    };
  }

  setEmployerData(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setEmployerID = event[0].ID;
    } else {
      this.setEmployerID = null;
    }
    this.mainForm.markAsDirty();
    this.mainForm.get('employer').setValue(this.setEmployerID);
    this.personPrefill.EmployerOrganizationID = this.setEmployerID;
  }

  initOccupation(disable: boolean): void {
    this.inputObjOccupation = {
      labelText: 'Occupation',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: this.personPrefill.OccupationRequired,
      data: this.personPrefill.OccupationOptions,
      selectFirstValue: false,
      initSelected: this.setOccupationID,
      disabled: disable,
      canWrite: true
    };
  }

  setOccupationData(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setOccupationID = event[0].ID;
    } else {
      this.setOccupationID = null;
    }
    this.mainForm.markAsDirty();
    this.mainForm.get('occupation').setValue(this.setOccupationID);
    this.personPrefill.OccupationID = this.setOccupationID;
  }

  initDuesGroup(disable: boolean): void {
    this.inputObjDuesGroup = {
      labelText: 'Dues Group',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: this.personPrefill.PersonProfileDuesGroupRequired,
      data: this.personPrefill.PersonProfileDuesGroupOptions,
      selectFirstValue: false,
      initSelected: this.setDuesGroupID,
      disabled: disable,
      canWrite: true
    };
  }

  setDuesGroupData(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setDuesGroupID = event[0].ID;
    } else {
      this.setDuesGroupID = null;
    }
    this.mainForm.markAsDirty();
    this.mainForm.get('duesGroup').setValue(this.setDuesGroupID);
    this.personPrefill.PersonProfileDuesGroupID = this.setDuesGroupID;
  }

  goToNextPage() {
    const tempAddress = {} as AddressModel;
    tempAddress.Address1 = this.registrationProfile.Address1;
    tempAddress.Address2 = this.registrationProfile.Address2;
    tempAddress.City = this.registrationProfile.City;
    tempAddress.StateProvinceID = this.registrationProfile.StateProvinceID;
    tempAddress.Zip = this.registrationProfile.Zip;
    tempAddress.CountryID = this.registrationProfile.CountryID;
    this.incomingAddressMailing = tempAddress;
    this.next.emit();
  }
}
